import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from '../../../pages/login/login.component';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { MatCard, MatCardContent, MatCardHeader } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { UpperCasePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-welcome',
  imports: [TranslocoModule, MatCardHeader, MatCardContent, MatCard, MatButton, UpperCasePipe],
  templateUrl: './welcome.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent {

  languageImageSource: string = '';
  languageImageSources: { [key: string]: string } = {
    en: "assets/img/flag-button-round-250-EN.png",
    sv: "assets/img/flag-button-round-250-SV.png",
  };

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<WelcomeComponent>,
    public translocoService: TranslocoService,
  ) { }

  ngOnInit(): void {
    let activeLanguage: string = this.translocoService.getActiveLang();
    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];
  }

  toggleLanguage() {
    let activeLanguage = this.translocoService.getActiveLang();
    if (activeLanguage == 'sv') {
      this.translocoService.setActiveLang('en');
    } else {
      this.translocoService.setActiveLang('sv');
    }
    activeLanguage = this.translocoService.getActiveLang();
    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];
  }

  continueAsGuest() {
    console.log('Continue as guest', this.dialogRef);
    this.dialogRef.close();
  }

  login() {
    this.dialog.open(LoginComponent, {
      width: '500px',
      disableClose: false,
      panelClass: 'login-dialog-panel',
      data: { forceMobileLayout: true }
    });
  }

  signup() {
    console.log('signup');
  }

}
